import React from "react";
import OptionNav from "../OptionNav/OptionNav";
import "./AppMenu.css";

function TopMenu({ name, options, ...props }) {
  const root = process.env.REACT_APP_CMS_STATIC;

  return (
    <div className="d-flex">
      {options.map((option, index) => {

        return (
          <OptionNav
            key={index}
            name={option?.displayText}
            icon={root + option?.icono?.urls[0]}
            title={option?.displayText}
            url={option?.rutadestino}
            textColor="#fff"
          />
        )

      })}
    </div>
  );
}
export default TopMenu;
